module.exports = __webpack_public_path__ + "static/Quicksand-Bold-05fcffc56e72bc6889ecea672078dc4f.ttf";